import { format, parse, subMonths } from "date-fns";

export const subAndFormatMonths = (
  dataString,
  amountOfMonths,
  initialFormat = "yyyy-MM-dd",
  newFormat = "yyyy-MM-dd"
) => {
  const date = parse(dataString, initialFormat, new Date());
  const newDate = subMonths(date, amountOfMonths);
  const formatedNewDate = format(newDate, "yyyy-MM-dd");

  return formatedNewDate;
};
